/**
 * Schema 注册表
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition, SchemaProperty } from './_schema'
import { AppVersionListReqSchema } from './app_version_list_req'
import { AppVersionListResSchema } from './app_version_list_res'
import { AppVersionDataSchema } from './app_version_data'
import { AppVersionCreateReqSchema } from './app_version_create_req'
import { AppVersionCreateResSchema } from './app_version_create_res'
import { AppVersionDeleteReqSchema } from './app_version_delete_req'
import { AppVersionDeleteResSchema } from './app_version_delete_res'
import { AppVersionUpdateReqSchema } from './app_version_update_req'
import { AppVersionUpdateResSchema } from './app_version_update_res'
import { AuthLoginReqSchema } from './auth_login_req'
import { AuthLoginResSchema } from './auth_login_res'
import { StaffDataSchema } from './staff_data'
import { StaffInfoSchema } from './staff_info'
import { StaffRoleInfoSchema } from './staff_role_info'
import { StaffStatsDataSchema } from './staff_stats_data'
import { AuthLogoutReqSchema } from './auth_logout_req'
import { AuthLogoutResSchema } from './auth_logout_res'
import { AuthRefreshReqSchema } from './auth_refresh_req'
import { AuthRefreshResSchema } from './auth_refresh_res'
import { AuthSendCaptchaReqSchema } from './auth_send_captcha_req'
import { AuthSendCaptchaResSchema } from './auth_send_captcha_res'
import { BattleListReqSchema } from './battle_list_req'
import { BattleListResSchema } from './battle_list_res'
import { BattleDataSchema } from './battle_data'
import { BattleInfoSchema } from './battle_info'
import { FileInfoSchema } from './file_info'
import { ImageMetadataSchema } from './image_metadata'
import { VideoMetadataSchema } from './video_metadata'
import { AudioMetadataSchema } from './audio_metadata'
import { BattleSettlementDataSchema } from './battle_settlement_data'
import { BattleRealtimeDataSchema } from './battle_realtime_data'
import { BattleTeamDataSchema } from './battle_team_data'
import { BattleCreateReqSchema } from './battle_create_req'
import { BattleCreateResSchema } from './battle_create_res'
import { BattleGetReqSchema } from './battle_get_req'
import { BattleGetResSchema } from './battle_get_res'
import { BattleUpdateReqSchema } from './battle_update_req'
import { BattleUpdateResSchema } from './battle_update_res'
import { BattleUpdateStageReqSchema } from './battle_update_stage_req'
import { BattleUpdateStageResSchema } from './battle_update_stage_res'
import { CampListReqSchema } from './camp_list_req'
import { CampListResSchema } from './camp_list_res'
import { CampDataSchema } from './camp_data'
import { CampInfoSchema } from './camp_info'
import { UserDataSchema } from './user_data'
import { UserInfoSchema } from './user_info'
import { UserStatsSchema } from './user_stats'
import { UserContactSchema } from './user_contact'
import { UserSettingSchema } from './user_setting'
import { UserOauthSchema } from './user_oauth'
import { CampCreateReqSchema } from './camp_create_req'
import { CampCreateResSchema } from './camp_create_res'
import { CampGetReqSchema } from './camp_get_req'
import { CampGetResSchema } from './camp_get_res'
import { CampUpdateReqSchema } from './camp_update_req'
import { CampUpdateResSchema } from './camp_update_res'
import { ChatChannelMemberListReqSchema } from './chat_channel_member_list_req'
import { ChatChannelMemberListResSchema } from './chat_channel_member_list_res'
import { ChatChannelMemberDataSchema } from './chat_channel_member_data'
import { ChatChannelMemberSchema } from './chat_channel_member'
import { ChatChannelDataSchema } from './chat_channel_data'
import { ChatChannelSchema } from './chat_channel'
import { ChatChannelMemberGetReqSchema } from './chat_channel_member_get_req'
import { ChatChannelMemberGetResSchema } from './chat_channel_member_get_res'
import { ChatChannelListReqSchema } from './chat_channel_list_req'
import { ChatChannelListResSchema } from './chat_channel_list_res'
import { ChatChannelGetReqSchema } from './chat_channel_get_req'
import { ChatChannelGetResSchema } from './chat_channel_get_res'
import { ChatMessageListReqSchema } from './chat_message_list_req'
import { ChatMessageListResSchema } from './chat_message_list_res'
import { ChatMessageDataSchema } from './chat_message_data'
import { ChatMessageSchema } from './chat_message'
import { ChatMessageAttachmentSchema } from './chat_message_attachment'
import { ChatMessageAttachmentExtraDataSchema } from './chat_message_attachment_extra_data'
import { ChatMessageDeleteReqSchema } from './chat_message_delete_req'
import { ChatMessageDeleteResSchema } from './chat_message_delete_res'
import { ChatMessageGetReqSchema } from './chat_message_get_req'
import { ChatMessageGetResSchema } from './chat_message_get_res'
import { CommentListReqSchema } from './comment_list_req'
import { CommentListResSchema } from './comment_list_res'
import { CommentDataSchema } from './comment_data'
import { CommentInfoSchema } from './comment_info'
import { UserBriefInfoSchema } from './user_brief_info'
import { CommentAttachmentSchema } from './comment_attachment'
import { CommentStatsSchema } from './comment_stats'
import { PostDataSchema } from './post_data'
import { PostInfoSchema } from './post_info'
import { PostAttachmentSchema } from './post_attachment'
import { PostStatsSchema } from './post_stats'
import { CommentCreateReqSchema } from './comment_create_req'
import { CommentCreateResSchema } from './comment_create_res'
import { CommentStatsRefreshReqSchema } from './comment_stats_refresh_req'
import { CommentStatsRefreshResSchema } from './comment_stats_refresh_res'
import { CommentDeleteReqSchema } from './comment_delete_req'
import { CommentDeleteResSchema } from './comment_delete_res'
import { CommentGetReqSchema } from './comment_get_req'
import { CommentGetResSchema } from './comment_get_res'
import { CommentUpdateReqSchema } from './comment_update_req'
import { CommentUpdateResSchema } from './comment_update_res'
import { CommentDisableReqSchema } from './comment_disable_req'
import { CommentDisableResSchema } from './comment_disable_res'
import { CommentEnableReqSchema } from './comment_enable_req'
import { CommentEnableResSchema } from './comment_enable_res'
import { DashboardActivitiesListReqSchema } from './dashboard_activities_list_req'
import { DashboardActivitiesListResSchema } from './dashboard_activities_list_res'
import { DashboardActivityOutputSchema } from './dashboard_activity_output'
import { DashboardActivitiesRecentReqSchema } from './dashboard_activities_recent_req'
import { DashboardActivitiesRecentResSchema } from './dashboard_activities_recent_res'
import { DashboardStatisticsReqSchema } from './dashboard_statistics_req'
import { DashboardStatisticsResSchema } from './dashboard_statistics_res'
import { DashboardStatisticsTrendReqSchema } from './dashboard_statistics_trend_req'
import { DashboardStatisticsTrendResSchema } from './dashboard_statistics_trend_res'
import { DashboardSystemInfoReqSchema } from './dashboard_system_info_req'
import { DashboardSystemInfoResSchema } from './dashboard_system_info_res'
import { DebugGetCaptchaReqSchema } from './debug_get_captcha_req'
import { DebugGetCaptchaResSchema } from './debug_get_captcha_res'
import { DebugLoginReqSchema } from './debug_login_req'
import { DebugLoginResSchema } from './debug_login_res'
import { DeviceListReqSchema } from './device_list_req'
import { DeviceListResSchema } from './device_list_res'
import { DeviceDataSchema } from './device_data'
import { DeviceInfoSchema } from './device_info'
import { DeviceGetReqSchema } from './device_get_req'
import { DeviceGetResSchema } from './device_get_res'
import { FileDeleteReqSchema } from './file_delete_req'
import { FileDeleteResSchema } from './file_delete_res'
import { FileDeleteFailedErrSchema } from './file_delete_failed_err'
import { FileListReqSchema } from './file_list_req'
import { FileListResSchema } from './file_list_res'
import { FileDataSchema } from './file_data'
import { FileStatsSchema } from './file_stats'
import { FileReferenceDataSchema } from './file_reference_data'
import { FileReferenceSchema } from './file_reference'
import { FileActionDataSchema } from './file_action_data'
import { FileActionSchema } from './file_action'
import { FileRandomReqSchema } from './file_random_req'
import { FileRandomResSchema } from './file_random_res'
import { FileUploadReqSchema } from './file_upload_req'
import { FileUploadResSchema } from './file_upload_res'
import { FileGetReqSchema } from './file_get_req'
import { FileGetResSchema } from './file_get_res'
import { GroupListReqSchema } from './group_list_req'
import { GroupListResSchema } from './group_list_res'
import { GroupDataSchema } from './group_data'
import { GroupGetReqSchema } from './group_get_req'
import { GroupGetResSchema } from './group_get_res'
import { NotificationListReqSchema } from './notification_list_req'
import { NotificationListResSchema } from './notification_list_res'
import { NotificationDataSchema } from './notification_data'
import { NotificationInfoSchema } from './notification_info'
import { NotificationResponseDataSchema } from './notification_response_data'
import { NotificationResponseSchema } from './notification_response'
import { NotificationStatsDataSchema } from './notification_stats_data'
import { NotificationGetReqSchema } from './notification_get_req'
import { NotificationGetResSchema } from './notification_get_res'
import { PostListReqSchema } from './post_list_req'
import { PostListResSchema } from './post_list_res'
import { PostCreateReqSchema } from './post_create_req'
import { PostCreateResSchema } from './post_create_res'
import { PostStatsRefreshReqSchema } from './post_stats_refresh_req'
import { PostStatsRefreshResSchema } from './post_stats_refresh_res'
import { PostDeleteReqSchema } from './post_delete_req'
import { PostDeleteResSchema } from './post_delete_res'
import { PostGetReqSchema } from './post_get_req'
import { PostGetResSchema } from './post_get_res'
import { PostUpdateReqSchema } from './post_update_req'
import { PostUpdateResSchema } from './post_update_res'
import { PostDisableReqSchema } from './post_disable_req'
import { PostDisableResSchema } from './post_disable_res'
import { PostEnableReqSchema } from './post_enable_req'
import { PostEnableResSchema } from './post_enable_res'
import { PostRestoreReqSchema } from './post_restore_req'
import { PostRestoreResSchema } from './post_restore_res'
import { ProfileGetReqSchema } from './profile_get_req'
import { ProfileGetResSchema } from './profile_get_res'
import { ProfileUpdateReqSchema } from './profile_update_req'
import { ProfileUpdateResSchema } from './profile_update_res'
import { ProfilePasswordReqSchema } from './profile_password_req'
import { ProfilePasswordResSchema } from './profile_password_res'
import { ProfilePermissionsReqSchema } from './profile_permissions_req'
import { ProfilePermissionsResSchema } from './profile_permissions_res'
import { SearchLogListReqSchema } from './search_log_list_req'
import { SearchLogListResSchema } from './search_log_list_res'
import { SearchLogDataSchema } from './search_log_data'
import { SearchLogSchema } from './search_log'
import { SearchTrendingListReqSchema } from './search_trending_list_req'
import { SearchTrendingListResSchema } from './search_trending_list_res'
import { SearchTrendingDataSchema } from './search_trending_data'
import { SearchTrendingSchema } from './search_trending'
import { StaffListReqSchema } from './staff_list_req'
import { StaffListResSchema } from './staff_list_res'
import { StaffCreateReqSchema } from './staff_create_req'
import { StaffCreateResSchema } from './staff_create_res'
import { StaffChangePasswordReqSchema } from './staff_change_password_req'
import { StaffChangePasswordResSchema } from './staff_change_password_res'
import { StaffDeleteReqSchema } from './staff_delete_req'
import { StaffDeleteResSchema } from './staff_delete_res'
import { StaffGetReqSchema } from './staff_get_req'
import { StaffGetResSchema } from './staff_get_res'
import { StaffUpdateReqSchema } from './staff_update_req'
import { StaffUpdateResSchema } from './staff_update_res'
import { StaffDisableReqSchema } from './staff_disable_req'
import { StaffDisableResSchema } from './staff_disable_res'
import { StaffEnableReqSchema } from './staff_enable_req'
import { StaffEnableResSchema } from './staff_enable_res'
import { StaffResetPasswordReqSchema } from './staff_reset_password_req'
import { StaffResetPasswordResSchema } from './staff_reset_password_res'
import { StaffRestoreReqSchema } from './staff_restore_req'
import { StaffRestoreResSchema } from './staff_restore_res'
import { StickerListReqSchema } from './sticker_list_req'
import { StickerListResSchema } from './sticker_list_res'
import { StickerDataSchema } from './sticker_data'
import { StickerInfoSchema } from './sticker_info'
import { StickerMediasSchema } from './sticker_medias'
import { StickerMediaItemSchema } from './sticker_media_item'
import { StickerCreateReqSchema } from './sticker_create_req'
import { StickerCreateResSchema } from './sticker_create_res'
import { StickerDeleteReqSchema } from './sticker_delete_req'
import { StickerDeleteResSchema } from './sticker_delete_res'
import { StickerGetReqSchema } from './sticker_get_req'
import { StickerGetResSchema } from './sticker_get_res'
import { StickerUpdateReqSchema } from './sticker_update_req'
import { StickerUpdateResSchema } from './sticker_update_res'
import { StickerDisableReqSchema } from './sticker_disable_req'
import { StickerDisableResSchema } from './sticker_disable_res'
import { StickerEnableReqSchema } from './sticker_enable_req'
import { StickerEnableResSchema } from './sticker_enable_res'
import { StickerRestoreReqSchema } from './sticker_restore_req'
import { StickerRestoreResSchema } from './sticker_restore_res'
import { StreamWebhookEventListReqSchema } from './stream_webhook_event_list_req'
import { StreamWebhookEventListResSchema } from './stream_webhook_event_list_res'
import { StreamWebhookEventDataSchema } from './stream_webhook_event_data'
import { UserRelationListReqSchema } from './user_relation_list_req'
import { UserRelationListResSchema } from './user_relation_list_res'
import { UserRelationDataSchema } from './user_relation_data'
import { UserRelationSchema } from './user_relation'
import { UserRelationGetReqSchema } from './user_relation_get_req'
import { UserRelationGetResSchema } from './user_relation_get_res'
import { UserListReqSchema } from './user_list_req'
import { UserListResSchema } from './user_list_res'
import { UserCreateReqSchema } from './user_create_req'
import { UserCreateResSchema } from './user_create_res'
import { UserStatsRefreshReqSchema } from './user_stats_refresh_req'
import { UserStatsRefreshResSchema } from './user_stats_refresh_res'
import { UserDeleteReqSchema } from './user_delete_req'
import { UserDeleteResSchema } from './user_delete_res'
import { UserGetReqSchema } from './user_get_req'
import { UserGetResSchema } from './user_get_res'
import { UserUpdateReqSchema } from './user_update_req'
import { UserUpdateResSchema } from './user_update_res'
import { UserDisableReqSchema } from './user_disable_req'
import { UserDisableResSchema } from './user_disable_res'
import { UserEnableReqSchema } from './user_enable_req'
import { UserEnableResSchema } from './user_enable_res'
import { UserRestoreReqSchema } from './user_restore_req'
import { UserRestoreResSchema } from './user_restore_res'
import { WatermillMessagesListReqSchema } from './watermill_messages_list_req'
import { WatermillMessagesListResSchema } from './watermill_messages_list_res'
import { WatermillMessageDataSchema } from './watermill_message_data'
import { WatermillTopicsReqSchema } from './watermill_topics_req'
import { WatermillTopicsResSchema } from './watermill_topics_res'
import { WatermillTopicInfoSchema } from './watermill_topic_info'

/**
 * 所有 Schema 键名类型
 */
export type SchemaKey =
  | 'AppVersionCreateReq'
  | 'AppVersionCreateRes'
  | 'AppVersionData'
  | 'AppVersionDeleteReq'
  | 'AppVersionDeleteRes'
  | 'AppVersionListReq'
  | 'AppVersionListRes'
  | 'AppVersionUpdateReq'
  | 'AppVersionUpdateRes'
  | 'AudioMetadata'
  | 'AuthLoginReq'
  | 'AuthLoginRes'
  | 'AuthLogoutReq'
  | 'AuthLogoutRes'
  | 'AuthRefreshReq'
  | 'AuthRefreshRes'
  | 'AuthSendCaptchaReq'
  | 'AuthSendCaptchaRes'
  | 'BattleCreateReq'
  | 'BattleCreateRes'
  | 'BattleData'
  | 'BattleGetReq'
  | 'BattleGetRes'
  | 'BattleInfo'
  | 'BattleListReq'
  | 'BattleListRes'
  | 'BattleRealtimeData'
  | 'BattleSettlementData'
  | 'BattleTeamData'
  | 'BattleUpdateReq'
  | 'BattleUpdateRes'
  | 'BattleUpdateStageReq'
  | 'BattleUpdateStageRes'
  | 'CampCreateReq'
  | 'CampCreateRes'
  | 'CampData'
  | 'CampGetReq'
  | 'CampGetRes'
  | 'CampInfo'
  | 'CampListReq'
  | 'CampListRes'
  | 'CampUpdateReq'
  | 'CampUpdateRes'
  | 'ChatChannel'
  | 'ChatChannelData'
  | 'ChatChannelGetReq'
  | 'ChatChannelGetRes'
  | 'ChatChannelListReq'
  | 'ChatChannelListRes'
  | 'ChatChannelMember'
  | 'ChatChannelMemberData'
  | 'ChatChannelMemberGetReq'
  | 'ChatChannelMemberGetRes'
  | 'ChatChannelMemberListReq'
  | 'ChatChannelMemberListRes'
  | 'ChatMessage'
  | 'ChatMessageAttachment'
  | 'ChatMessageAttachmentExtraData'
  | 'ChatMessageData'
  | 'ChatMessageDeleteReq'
  | 'ChatMessageDeleteRes'
  | 'ChatMessageGetReq'
  | 'ChatMessageGetRes'
  | 'ChatMessageListReq'
  | 'ChatMessageListRes'
  | 'CommentAttachment'
  | 'CommentCreateReq'
  | 'CommentCreateRes'
  | 'CommentData'
  | 'CommentDeleteReq'
  | 'CommentDeleteRes'
  | 'CommentDisableReq'
  | 'CommentDisableRes'
  | 'CommentEnableReq'
  | 'CommentEnableRes'
  | 'CommentGetReq'
  | 'CommentGetRes'
  | 'CommentInfo'
  | 'CommentListReq'
  | 'CommentListRes'
  | 'CommentStats'
  | 'CommentStatsRefreshReq'
  | 'CommentStatsRefreshRes'
  | 'CommentUpdateReq'
  | 'CommentUpdateRes'
  | 'DashboardActivitiesListReq'
  | 'DashboardActivitiesListRes'
  | 'DashboardActivitiesRecentReq'
  | 'DashboardActivitiesRecentRes'
  | 'DashboardActivityOutput'
  | 'DashboardStatisticsReq'
  | 'DashboardStatisticsRes'
  | 'DashboardStatisticsTrendReq'
  | 'DashboardStatisticsTrendRes'
  | 'DashboardSystemInfoReq'
  | 'DashboardSystemInfoRes'
  | 'DebugGetCaptchaReq'
  | 'DebugGetCaptchaRes'
  | 'DebugLoginReq'
  | 'DebugLoginRes'
  | 'DeviceData'
  | 'DeviceGetReq'
  | 'DeviceGetRes'
  | 'DeviceInfo'
  | 'DeviceListReq'
  | 'DeviceListRes'
  | 'FileAction'
  | 'FileActionData'
  | 'FileData'
  | 'FileDeleteFailedErr'
  | 'FileDeleteReq'
  | 'FileDeleteRes'
  | 'FileGetReq'
  | 'FileGetRes'
  | 'FileInfo'
  | 'FileListReq'
  | 'FileListRes'
  | 'FileRandomReq'
  | 'FileRandomRes'
  | 'FileReference'
  | 'FileReferenceData'
  | 'FileStats'
  | 'FileUploadReq'
  | 'FileUploadRes'
  | 'GroupData'
  | 'GroupGetReq'
  | 'GroupGetRes'
  | 'GroupListReq'
  | 'GroupListRes'
  | 'ImageMetadata'
  | 'NotificationData'
  | 'NotificationGetReq'
  | 'NotificationGetRes'
  | 'NotificationInfo'
  | 'NotificationListReq'
  | 'NotificationListRes'
  | 'NotificationResponse'
  | 'NotificationResponseData'
  | 'NotificationStatsData'
  | 'PostAttachment'
  | 'PostCreateReq'
  | 'PostCreateRes'
  | 'PostData'
  | 'PostDeleteReq'
  | 'PostDeleteRes'
  | 'PostDisableReq'
  | 'PostDisableRes'
  | 'PostEnableReq'
  | 'PostEnableRes'
  | 'PostGetReq'
  | 'PostGetRes'
  | 'PostInfo'
  | 'PostListReq'
  | 'PostListRes'
  | 'PostRestoreReq'
  | 'PostRestoreRes'
  | 'PostStats'
  | 'PostStatsRefreshReq'
  | 'PostStatsRefreshRes'
  | 'PostUpdateReq'
  | 'PostUpdateRes'
  | 'ProfileGetReq'
  | 'ProfileGetRes'
  | 'ProfilePasswordReq'
  | 'ProfilePasswordRes'
  | 'ProfilePermissionsReq'
  | 'ProfilePermissionsRes'
  | 'ProfileUpdateReq'
  | 'ProfileUpdateRes'
  | 'SearchLog'
  | 'SearchLogData'
  | 'SearchLogListReq'
  | 'SearchLogListRes'
  | 'SearchTrending'
  | 'SearchTrendingData'
  | 'SearchTrendingListReq'
  | 'SearchTrendingListRes'
  | 'StaffChangePasswordReq'
  | 'StaffChangePasswordRes'
  | 'StaffCreateReq'
  | 'StaffCreateRes'
  | 'StaffData'
  | 'StaffDeleteReq'
  | 'StaffDeleteRes'
  | 'StaffDisableReq'
  | 'StaffDisableRes'
  | 'StaffEnableReq'
  | 'StaffEnableRes'
  | 'StaffGetReq'
  | 'StaffGetRes'
  | 'StaffInfo'
  | 'StaffListReq'
  | 'StaffListRes'
  | 'StaffResetPasswordReq'
  | 'StaffResetPasswordRes'
  | 'StaffRestoreReq'
  | 'StaffRestoreRes'
  | 'StaffRoleInfo'
  | 'StaffStatsData'
  | 'StaffUpdateReq'
  | 'StaffUpdateRes'
  | 'StickerCreateReq'
  | 'StickerCreateRes'
  | 'StickerData'
  | 'StickerDeleteReq'
  | 'StickerDeleteRes'
  | 'StickerDisableReq'
  | 'StickerDisableRes'
  | 'StickerEnableReq'
  | 'StickerEnableRes'
  | 'StickerGetReq'
  | 'StickerGetRes'
  | 'StickerInfo'
  | 'StickerListReq'
  | 'StickerListRes'
  | 'StickerMediaItem'
  | 'StickerMedias'
  | 'StickerRestoreReq'
  | 'StickerRestoreRes'
  | 'StickerUpdateReq'
  | 'StickerUpdateRes'
  | 'StreamWebhookEventData'
  | 'StreamWebhookEventListReq'
  | 'StreamWebhookEventListRes'
  | 'UserBriefInfo'
  | 'UserContact'
  | 'UserCreateReq'
  | 'UserCreateRes'
  | 'UserData'
  | 'UserDeleteReq'
  | 'UserDeleteRes'
  | 'UserDisableReq'
  | 'UserDisableRes'
  | 'UserEnableReq'
  | 'UserEnableRes'
  | 'UserGetReq'
  | 'UserGetRes'
  | 'UserInfo'
  | 'UserListReq'
  | 'UserListRes'
  | 'UserOauth'
  | 'UserRelation'
  | 'UserRelationData'
  | 'UserRelationGetReq'
  | 'UserRelationGetRes'
  | 'UserRelationListReq'
  | 'UserRelationListRes'
  | 'UserRestoreReq'
  | 'UserRestoreRes'
  | 'UserSetting'
  | 'UserStats'
  | 'UserStatsRefreshReq'
  | 'UserStatsRefreshRes'
  | 'UserUpdateReq'
  | 'UserUpdateRes'
  | 'VideoMetadata'
  | 'WatermillMessageData'
  | 'WatermillMessagesListReq'
  | 'WatermillMessagesListRes'
  | 'WatermillTopicInfo'
  | 'WatermillTopicsReq'
  | 'WatermillTopicsRes'

/**
 * Schemas - 所有 Schema 定义的集合
 * 用于根据 Schema 名称查找对应的 Schema 定义
 */
export const Schemas: Record<SchemaKey, SchemaDefinition> = {
  AppVersionCreateReq: AppVersionCreateReqSchema,
  AppVersionCreateRes: AppVersionCreateResSchema,
  AppVersionData: AppVersionDataSchema,
  AppVersionDeleteReq: AppVersionDeleteReqSchema,
  AppVersionDeleteRes: AppVersionDeleteResSchema,
  AppVersionListReq: AppVersionListReqSchema,
  AppVersionListRes: AppVersionListResSchema,
  AppVersionUpdateReq: AppVersionUpdateReqSchema,
  AppVersionUpdateRes: AppVersionUpdateResSchema,
  AudioMetadata: AudioMetadataSchema,
  AuthLoginReq: AuthLoginReqSchema,
  AuthLoginRes: AuthLoginResSchema,
  AuthLogoutReq: AuthLogoutReqSchema,
  AuthLogoutRes: AuthLogoutResSchema,
  AuthRefreshReq: AuthRefreshReqSchema,
  AuthRefreshRes: AuthRefreshResSchema,
  AuthSendCaptchaReq: AuthSendCaptchaReqSchema,
  AuthSendCaptchaRes: AuthSendCaptchaResSchema,
  BattleCreateReq: BattleCreateReqSchema,
  BattleCreateRes: BattleCreateResSchema,
  BattleData: BattleDataSchema,
  BattleGetReq: BattleGetReqSchema,
  BattleGetRes: BattleGetResSchema,
  BattleInfo: BattleInfoSchema,
  BattleListReq: BattleListReqSchema,
  BattleListRes: BattleListResSchema,
  BattleRealtimeData: BattleRealtimeDataSchema,
  BattleSettlementData: BattleSettlementDataSchema,
  BattleTeamData: BattleTeamDataSchema,
  BattleUpdateReq: BattleUpdateReqSchema,
  BattleUpdateRes: BattleUpdateResSchema,
  BattleUpdateStageReq: BattleUpdateStageReqSchema,
  BattleUpdateStageRes: BattleUpdateStageResSchema,
  CampCreateReq: CampCreateReqSchema,
  CampCreateRes: CampCreateResSchema,
  CampData: CampDataSchema,
  CampGetReq: CampGetReqSchema,
  CampGetRes: CampGetResSchema,
  CampInfo: CampInfoSchema,
  CampListReq: CampListReqSchema,
  CampListRes: CampListResSchema,
  CampUpdateReq: CampUpdateReqSchema,
  CampUpdateRes: CampUpdateResSchema,
  ChatChannel: ChatChannelSchema,
  ChatChannelData: ChatChannelDataSchema,
  ChatChannelGetReq: ChatChannelGetReqSchema,
  ChatChannelGetRes: ChatChannelGetResSchema,
  ChatChannelListReq: ChatChannelListReqSchema,
  ChatChannelListRes: ChatChannelListResSchema,
  ChatChannelMember: ChatChannelMemberSchema,
  ChatChannelMemberData: ChatChannelMemberDataSchema,
  ChatChannelMemberGetReq: ChatChannelMemberGetReqSchema,
  ChatChannelMemberGetRes: ChatChannelMemberGetResSchema,
  ChatChannelMemberListReq: ChatChannelMemberListReqSchema,
  ChatChannelMemberListRes: ChatChannelMemberListResSchema,
  ChatMessage: ChatMessageSchema,
  ChatMessageAttachment: ChatMessageAttachmentSchema,
  ChatMessageAttachmentExtraData: ChatMessageAttachmentExtraDataSchema,
  ChatMessageData: ChatMessageDataSchema,
  ChatMessageDeleteReq: ChatMessageDeleteReqSchema,
  ChatMessageDeleteRes: ChatMessageDeleteResSchema,
  ChatMessageGetReq: ChatMessageGetReqSchema,
  ChatMessageGetRes: ChatMessageGetResSchema,
  ChatMessageListReq: ChatMessageListReqSchema,
  ChatMessageListRes: ChatMessageListResSchema,
  CommentAttachment: CommentAttachmentSchema,
  CommentCreateReq: CommentCreateReqSchema,
  CommentCreateRes: CommentCreateResSchema,
  CommentData: CommentDataSchema,
  CommentDeleteReq: CommentDeleteReqSchema,
  CommentDeleteRes: CommentDeleteResSchema,
  CommentDisableReq: CommentDisableReqSchema,
  CommentDisableRes: CommentDisableResSchema,
  CommentEnableReq: CommentEnableReqSchema,
  CommentEnableRes: CommentEnableResSchema,
  CommentGetReq: CommentGetReqSchema,
  CommentGetRes: CommentGetResSchema,
  CommentInfo: CommentInfoSchema,
  CommentListReq: CommentListReqSchema,
  CommentListRes: CommentListResSchema,
  CommentStats: CommentStatsSchema,
  CommentStatsRefreshReq: CommentStatsRefreshReqSchema,
  CommentStatsRefreshRes: CommentStatsRefreshResSchema,
  CommentUpdateReq: CommentUpdateReqSchema,
  CommentUpdateRes: CommentUpdateResSchema,
  DashboardActivitiesListReq: DashboardActivitiesListReqSchema,
  DashboardActivitiesListRes: DashboardActivitiesListResSchema,
  DashboardActivitiesRecentReq: DashboardActivitiesRecentReqSchema,
  DashboardActivitiesRecentRes: DashboardActivitiesRecentResSchema,
  DashboardActivityOutput: DashboardActivityOutputSchema,
  DashboardStatisticsReq: DashboardStatisticsReqSchema,
  DashboardStatisticsRes: DashboardStatisticsResSchema,
  DashboardStatisticsTrendReq: DashboardStatisticsTrendReqSchema,
  DashboardStatisticsTrendRes: DashboardStatisticsTrendResSchema,
  DashboardSystemInfoReq: DashboardSystemInfoReqSchema,
  DashboardSystemInfoRes: DashboardSystemInfoResSchema,
  DebugGetCaptchaReq: DebugGetCaptchaReqSchema,
  DebugGetCaptchaRes: DebugGetCaptchaResSchema,
  DebugLoginReq: DebugLoginReqSchema,
  DebugLoginRes: DebugLoginResSchema,
  DeviceData: DeviceDataSchema,
  DeviceGetReq: DeviceGetReqSchema,
  DeviceGetRes: DeviceGetResSchema,
  DeviceInfo: DeviceInfoSchema,
  DeviceListReq: DeviceListReqSchema,
  DeviceListRes: DeviceListResSchema,
  FileAction: FileActionSchema,
  FileActionData: FileActionDataSchema,
  FileData: FileDataSchema,
  FileDeleteFailedErr: FileDeleteFailedErrSchema,
  FileDeleteReq: FileDeleteReqSchema,
  FileDeleteRes: FileDeleteResSchema,
  FileGetReq: FileGetReqSchema,
  FileGetRes: FileGetResSchema,
  FileInfo: FileInfoSchema,
  FileListReq: FileListReqSchema,
  FileListRes: FileListResSchema,
  FileRandomReq: FileRandomReqSchema,
  FileRandomRes: FileRandomResSchema,
  FileReference: FileReferenceSchema,
  FileReferenceData: FileReferenceDataSchema,
  FileStats: FileStatsSchema,
  FileUploadReq: FileUploadReqSchema,
  FileUploadRes: FileUploadResSchema,
  GroupData: GroupDataSchema,
  GroupGetReq: GroupGetReqSchema,
  GroupGetRes: GroupGetResSchema,
  GroupListReq: GroupListReqSchema,
  GroupListRes: GroupListResSchema,
  ImageMetadata: ImageMetadataSchema,
  NotificationData: NotificationDataSchema,
  NotificationGetReq: NotificationGetReqSchema,
  NotificationGetRes: NotificationGetResSchema,
  NotificationInfo: NotificationInfoSchema,
  NotificationListReq: NotificationListReqSchema,
  NotificationListRes: NotificationListResSchema,
  NotificationResponse: NotificationResponseSchema,
  NotificationResponseData: NotificationResponseDataSchema,
  NotificationStatsData: NotificationStatsDataSchema,
  PostAttachment: PostAttachmentSchema,
  PostCreateReq: PostCreateReqSchema,
  PostCreateRes: PostCreateResSchema,
  PostData: PostDataSchema,
  PostDeleteReq: PostDeleteReqSchema,
  PostDeleteRes: PostDeleteResSchema,
  PostDisableReq: PostDisableReqSchema,
  PostDisableRes: PostDisableResSchema,
  PostEnableReq: PostEnableReqSchema,
  PostEnableRes: PostEnableResSchema,
  PostGetReq: PostGetReqSchema,
  PostGetRes: PostGetResSchema,
  PostInfo: PostInfoSchema,
  PostListReq: PostListReqSchema,
  PostListRes: PostListResSchema,
  PostRestoreReq: PostRestoreReqSchema,
  PostRestoreRes: PostRestoreResSchema,
  PostStats: PostStatsSchema,
  PostStatsRefreshReq: PostStatsRefreshReqSchema,
  PostStatsRefreshRes: PostStatsRefreshResSchema,
  PostUpdateReq: PostUpdateReqSchema,
  PostUpdateRes: PostUpdateResSchema,
  ProfileGetReq: ProfileGetReqSchema,
  ProfileGetRes: ProfileGetResSchema,
  ProfilePasswordReq: ProfilePasswordReqSchema,
  ProfilePasswordRes: ProfilePasswordResSchema,
  ProfilePermissionsReq: ProfilePermissionsReqSchema,
  ProfilePermissionsRes: ProfilePermissionsResSchema,
  ProfileUpdateReq: ProfileUpdateReqSchema,
  ProfileUpdateRes: ProfileUpdateResSchema,
  SearchLog: SearchLogSchema,
  SearchLogData: SearchLogDataSchema,
  SearchLogListReq: SearchLogListReqSchema,
  SearchLogListRes: SearchLogListResSchema,
  SearchTrending: SearchTrendingSchema,
  SearchTrendingData: SearchTrendingDataSchema,
  SearchTrendingListReq: SearchTrendingListReqSchema,
  SearchTrendingListRes: SearchTrendingListResSchema,
  StaffChangePasswordReq: StaffChangePasswordReqSchema,
  StaffChangePasswordRes: StaffChangePasswordResSchema,
  StaffCreateReq: StaffCreateReqSchema,
  StaffCreateRes: StaffCreateResSchema,
  StaffData: StaffDataSchema,
  StaffDeleteReq: StaffDeleteReqSchema,
  StaffDeleteRes: StaffDeleteResSchema,
  StaffDisableReq: StaffDisableReqSchema,
  StaffDisableRes: StaffDisableResSchema,
  StaffEnableReq: StaffEnableReqSchema,
  StaffEnableRes: StaffEnableResSchema,
  StaffGetReq: StaffGetReqSchema,
  StaffGetRes: StaffGetResSchema,
  StaffInfo: StaffInfoSchema,
  StaffListReq: StaffListReqSchema,
  StaffListRes: StaffListResSchema,
  StaffResetPasswordReq: StaffResetPasswordReqSchema,
  StaffResetPasswordRes: StaffResetPasswordResSchema,
  StaffRestoreReq: StaffRestoreReqSchema,
  StaffRestoreRes: StaffRestoreResSchema,
  StaffRoleInfo: StaffRoleInfoSchema,
  StaffStatsData: StaffStatsDataSchema,
  StaffUpdateReq: StaffUpdateReqSchema,
  StaffUpdateRes: StaffUpdateResSchema,
  StickerCreateReq: StickerCreateReqSchema,
  StickerCreateRes: StickerCreateResSchema,
  StickerData: StickerDataSchema,
  StickerDeleteReq: StickerDeleteReqSchema,
  StickerDeleteRes: StickerDeleteResSchema,
  StickerDisableReq: StickerDisableReqSchema,
  StickerDisableRes: StickerDisableResSchema,
  StickerEnableReq: StickerEnableReqSchema,
  StickerEnableRes: StickerEnableResSchema,
  StickerGetReq: StickerGetReqSchema,
  StickerGetRes: StickerGetResSchema,
  StickerInfo: StickerInfoSchema,
  StickerListReq: StickerListReqSchema,
  StickerListRes: StickerListResSchema,
  StickerMediaItem: StickerMediaItemSchema,
  StickerMedias: StickerMediasSchema,
  StickerRestoreReq: StickerRestoreReqSchema,
  StickerRestoreRes: StickerRestoreResSchema,
  StickerUpdateReq: StickerUpdateReqSchema,
  StickerUpdateRes: StickerUpdateResSchema,
  StreamWebhookEventData: StreamWebhookEventDataSchema,
  StreamWebhookEventListReq: StreamWebhookEventListReqSchema,
  StreamWebhookEventListRes: StreamWebhookEventListResSchema,
  UserBriefInfo: UserBriefInfoSchema,
  UserContact: UserContactSchema,
  UserCreateReq: UserCreateReqSchema,
  UserCreateRes: UserCreateResSchema,
  UserData: UserDataSchema,
  UserDeleteReq: UserDeleteReqSchema,
  UserDeleteRes: UserDeleteResSchema,
  UserDisableReq: UserDisableReqSchema,
  UserDisableRes: UserDisableResSchema,
  UserEnableReq: UserEnableReqSchema,
  UserEnableRes: UserEnableResSchema,
  UserGetReq: UserGetReqSchema,
  UserGetRes: UserGetResSchema,
  UserInfo: UserInfoSchema,
  UserListReq: UserListReqSchema,
  UserListRes: UserListResSchema,
  UserOauth: UserOauthSchema,
  UserRelation: UserRelationSchema,
  UserRelationData: UserRelationDataSchema,
  UserRelationGetReq: UserRelationGetReqSchema,
  UserRelationGetRes: UserRelationGetResSchema,
  UserRelationListReq: UserRelationListReqSchema,
  UserRelationListRes: UserRelationListResSchema,
  UserRestoreReq: UserRestoreReqSchema,
  UserRestoreRes: UserRestoreResSchema,
  UserSetting: UserSettingSchema,
  UserStats: UserStatsSchema,
  UserStatsRefreshReq: UserStatsRefreshReqSchema,
  UserStatsRefreshRes: UserStatsRefreshResSchema,
  UserUpdateReq: UserUpdateReqSchema,
  UserUpdateRes: UserUpdateResSchema,
  VideoMetadata: VideoMetadataSchema,
  WatermillMessageData: WatermillMessageDataSchema,
  WatermillMessagesListReq: WatermillMessagesListReqSchema,
  WatermillMessagesListRes: WatermillMessagesListResSchema,
  WatermillTopicInfo: WatermillTopicInfoSchema,
  WatermillTopicsReq: WatermillTopicsReqSchema,
  WatermillTopicsRes: WatermillTopicsResSchema,
}

/**
 * 根据 Schema 名称获取 Schema 定义
 *
 * @param schemaKey - Schema 键名
 * @param expand - 是否展开 $ref 引用（默认 true）
 * @param maxDepth - 最大展开深度（默认 4）
 * @returns Schema 定义，如果不存在则返回 undefined
 */
export function getSchema(
  schemaKey: SchemaKey,
  expand: boolean = true,
  maxDepth: number = 4
): SchemaDefinition | undefined {
  const schema = Schemas[schemaKey]
  if (!schema) {
    return undefined
  }

  // 如果不需要展开，直接返回原始 schema
  if (!expand) {
    return schema
  }

  // 展开 $ref 引用
  return expandSchema(schema, maxDepth)
}

/**
 * 递归展开 Schema 中的 $ref 引用
 *
 * @param schema - 要展开的 Schema
 * @param maxDepth - 剩余的最大展开深度
 * @returns 展开后的 Schema
 */
function expandSchema(schema: SchemaDefinition, maxDepth: number): SchemaDefinition {
  // 如果达到最大深度，返回原始 schema（不再展开）
  if (maxDepth <= 0) {
    return schema
  }

  // 如果是 $ref 引用
  if (schema.$ref) {
    const refKey = schema.$ref as SchemaKey

    // 获取引用的 Schema
    const refSchema = Schemas[refKey]
    if (!refSchema) {
      return schema
    }

    // 递归展开引用的 Schema
    return expandSchema(refSchema, maxDepth - 1)
  }

  // 展开 properties 中的 $ref
  if (schema.properties) {
    const expandedProperties: Record<string, SchemaProperty> = {}
    for (const [key, prop] of Object.entries(schema.properties)) {
      expandedProperties[key] = expandSchema(prop, maxDepth - 1)
    }
    return { ...schema, properties: expandedProperties }
  }

  // 展开 items 中的 $ref（数组类型）
  if (schema.items) {
    const expandedItems = expandSchema(schema.items, maxDepth - 1)
    return { ...schema, items: expandedItems }
  }

  // 其他情况直接返回
  return schema
}
